import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '@fleet-beat/core';
import { AuthService } from '@fleet-beat/shared';

interface NavigationItem {
  id: string;
  type: 'link' | 'gap' | 'group';
  children: NavigationItem[];
  disallowedRoles?: `${UserRole}`[];
}

@Pipe({
  name: 'disallowRoutesByRole',
})
export class DisallowRoutesByRolePipe implements PipeTransform {
  constructor(private authService: AuthService) {}
  transform(routesToFilter: NavigationItem[]): NavigationItem[] {
    if (!routesToFilter.length) return routesToFilter;
    const filteredRoutes: NavigationItem[] = routesToFilter
      .filter((route: NavigationItem) => {
        const canAccess: boolean = !route?.disallowedRoles?.includes(this.authService?.authUser?.role);
        return canAccess;
      })
      .map((route: NavigationItem) => {
        if (route.children?.length) {
          return {
            ...route,
            children: route.children.filter((cRoute: NavigationItem) => {
              const canAccess: boolean = !cRoute?.disallowedRoles?.includes(this.authService?.authUser?.role);
              return canAccess;
            }),
          };
        } else {
          return route;
        }
      });
    return filteredRoutes;
  }
}
